import React, { createContext, useState, useContext, useEffect, useCallback } from "react";
import SummaryApi from "../common";
import { toast } from "react-toastify";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const updateUser = (userData) => setUser(userData);

  const fetchcurrentuser = useCallback(async () => {
    if (!authToken) return;
    // setLoading(true);
    try {
      const response = await fetch(SummaryApi.getCurrentUser.url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.success) {
        setUser({ ...data.data, id: data.data._id });
      } else {
        console.error("Failed to fetch user:", data.message);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading(false);
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken) fetchcurrentuser();
    else setLoading(false);
  }, [authToken, fetchcurrentuser]); 

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "authToken") {
        setAuthToken(event.newValue);
        if (event.newValue) fetchcurrentuser();
        else setUser(null);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [fetchcurrentuser]); 

  //storing token only when the loggin not when signUp 
  //the reason adding comment coz when we register the backend register endpoint 
  //sending token along that we don't need while login and in current codebase 
  //we are not doing anything with it too so cunclution no need to return token while
  //login 
  const login = (token) => {

    setAuthToken(token);
    localStorage.setItem("authToken", token);
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    localStorage.removeItem("authToken");
  };

  const renewSubscriptino = async(renewData)=>{
    console.log(renewData);
    try{
      const response = await fetch(SummaryApi.renewSubscription.url,{
        method:SummaryApi.renewSubscription.method,
        headers:{
            "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,                
        },
        body: JSON.stringify(renewData)
      })
      const data = await response.json();
      if(!response.ok){
        console.log('failed to subscription')
        toast.error(data.message);
        return false;
      }
      toast.success(data.message)
      setUser(data.user);
      return true;
    }catch(err){
      console.log('Renewal error');
      return false;
    }
  }

  return (
    <AuthContext.Provider
      value={{ authToken, user, authLoading:loading, login, logout, fetchcurrentuser, updateUser, renewSubscriptino }}
    >
      {children}
    </AuthContext.Provider>
  );
};
